import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserModel } from '@common/models/User.model';
import { KendoMessageService } from '@common/services/kendoMessage.service';
import { currentUserSubject, UserService } from '@common/services/user.service';
import { isMobile } from '@common/utils/isMobile';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { StateService } from './singleton-services/state.service';

@Component({
    template: `
        @if (!isMobile) {
            <div class="jumbotron">
                <div class="row">
                    <div class="col-2">
                        <img src="../assets/img/Bulgarian-Port_logo.png" style="width: 80%;" />
                    </div>
                    <div class="col-4">
                        <h1 class="display-4" style="margin-top: 15px; margin-left: -30px">BulPCS</h1>
                    </div>
                </div>
            </div>
        }
        @if (isMobile) {
            <div class="jumbotron">
                <div class="row">
                    <div class="col-3"><h1 class="display-4">BulPCS</h1></div>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent {
    isMobile = isMobile();
    user: UserModel;

    constructor(
        private router: Router,
        private userService: UserService,
        private stateService: StateService,
        private translateService: TranslateService,
        private messageService: MessageService
    ) {
        currentUserSubject.subscribe((user) => {
            this.user = user;
        });

        if (this.user) {
            // Set the current user language
            this.userService.setCurrentLanguage(this.user.language.id, this.stateService.getSignInType()).then(() => {
                this.translateService.use(this.user.language.id.toLowerCase());
                localStorage.setItem('language', this.user.language.id);

                const msgs = <KendoMessageService>this.messageService;
                msgs.language = this.user.language.id.toLowerCase();
            });

            if (!this.user.hasAnyPermission()) {
                this.router.navigate(['/profile']);
            } else {
                this.router.navigate(['/vessel-visit/visit/list']);
            }
        } else {
            this.router.navigate(['/login']);
        }
    }
}
